<template>
  <div class="container video-wrapper">
    <div class="video-inner" style="position: relative"></div>
    <div class="video-content" :class="{ play }" @click="videoToggle">
      <iframe
        width="100%"
        height="100%"
        :src="videoURL"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
      <div class="player-wrapper">
        <div class="player"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      play: false,
      videoURL:
        "https://www.youtube.com/embed/d0Uwyw4mJhI?si=joXoFSfs96zmiaYG&controls=0&modestbranding=0&playlist=d0Uwyw4mJhI&loop=1&autoplay=1&mute=1",
    };
  },
  watch: {
    play() {
      this.videoURL =
        "https://www.youtube.com/embed/d0Uwyw4mJhI?si=joXoFSfs96zmiaYG&controls=0&modestbranding=0&playlist=d0Uwyw4mJhI&loop=1";
    },
  },
  methods: {
    videoToggle() {
      if (!this.play) {
        this.play = !this.play;
      }
    },
  },
};
</script>

<style>
.video-wrapper {
  display: flex;
  background: #e3e3e3;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
}

.video-inner {
  padding-bottom: 56.25%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video-content {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #e3e3e3;
}
.video-content:after {
  height: 100%;
  width: 100%;
  border-radius: 8px;
  content: "";
  background: radial-gradient(
    rgba(0, 0, 0, 0) 0,
    transparent 10%,
    rgba(0, 0, 0, 0.8) 100%
  );
  top: 0;
  left: 0;
  right: 0;
  position: absolute;
}
.play .player-wrapper {
  display: none;
}
.play:after {
  content: none !important;
}
.player-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: transparent;
  padding: 0;
  margin: 0;
  border: 0;
  box-shadow: none;
  z-index: 10;
}
.player {
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-left: 25px solid hsla(0, 0%, 100%, 0.3);
  border-bottom: 15px solid transparent;
  transition: border-left 0.25s;
}
.video-content:hover .player {
  border-left: 25px solid hsla(0, 0%, 100%, 0.7);
  transition: border-left 0.25s;
}
</style>
